<template>
  <div>
    <div v-for="(list, index) of treeDataSource" :key="index" :class="classTree">
      <div
        class="tree-list-head-list"
        :class="{ cur: list.foreignId === $store.state.frameworkId }"
        @click.stop="selectModule(list)"
      >
        <span>
          <i
            :class="{ 'treelist-arrow-bt': list.expanded, 'treelist-arrow-left': !list.expanded }"
            @click.stop="open(list, index)"
          ></i>
          <i class="treelist-file"></i>
        </span>
        <span class="cutting-word">{{ list.name }}</span>
        <span v-if="isOptionsShow" class="treelist-file-add" @click="fileAdd()"><i class="sign-icon-add"></i></span>
      </div>
      <div v-if="list.expanded" class="tree-list">
        <fa-tree-item
          v-for="(item, idx) in list.children"
          :key="idx"
          :data="item"
          :is-options-show="isOptionsShow"
          :index="idx"
          :is-add="isAdd"
          @clearInput="clearInput"
          @selectModule="selectModule"
          @rename="rename"
          @deleteFile="deleteFile"
        ></fa-tree-item>
      </div>
    </div>
  </div>
</template>
<script>
  import treeItem from './treeItem.vue'
  import { constants } from 'crypto'
  export default {
    name: 'FddTree',
    components: {
      'fa-tree-item': treeItem
    },
    props: {
      //数据源
      data: {
        type: Array,
        default: () => []
      },
      //树形结构菜单样式
      classTree: {
        type: String,
        default: 'nav-add-new-batch'
      },
      //是否显示多操作
      isOptionsShow: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        treeDataSource: [],
        isAdd: false //是否为添加
      }
    },
    watch: {
      data: {
        deep: true,
        handler: function() {
          this.initDate()
        }
      }
    },
    created() {
      this.initDate()
    },
    methods: {
      //初始化数据源信息
      initDate() {
        let templateList = JSON.parse(JSON.stringify(this.data))
        let recurrenceFunc = data => {
          for (let i = 0; i < data.length; i++) {
            data[i].expanded = true
            data[i].foreignId = data[i].id
            if (data[i].isRename) {
              data[i].isRename = true
            } else {
              data[i].isRename = false
            }
            data[i].children = data[i].children || []
            if (data[i].children.length > 0) {
              recurrenceFunc(data[i].children)
            }
          }
        }
        recurrenceFunc(templateList)
        this.treeDataSource = JSON.parse(JSON.stringify(templateList))
      },
      //添加文件夹
      fileAdd() {
        this.isAdd = true
        this.$emit('fileAdd', true)
      },
      //点击展开/收起树形菜单
      open(m, index) {
        m.expanded = !m.expanded
      },
      //重命名
      rename(m) {
        this.$emit('rename', m)
      },
      //取消
      clearInput(m) {
        this.$emit('clearInput', m)
      },
      //删除文件夹
      deleteFile(value) {
        this.$emit('deleteFile', value)
      },
      //获取选中的数据
      selectModule(list) {
        this.$store.commit('selectFrameworkId', list.id)
        this.$emit('selectModule', list)
      }
    }
  }
</script>
